var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93301 8.25C2.74056 8.58333 2.25944 8.58333 2.06699 8.25L0.767949 6C0.575499 5.66667 0.816062 5.25 1.20096 5.25L3.79904 5.25C4.18394 5.25 4.4245 5.66667 4.23205 6L2.93301 8.25Z",
    fill: "#202370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06699 0.75C2.25944 0.416667 2.74056 0.416667 2.93301 0.75L4.23205 3C4.4245 3.33333 4.18394 3.75 3.79904 3.75L1.20096 3.75C0.816062 3.75 0.575499 3.33333 0.767949 3L2.06699 0.75Z",
    fill: "#202370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.21b0115ad8ad6efe724cb4ffeda47dfe.svg";
export { ForwardRef as ReactComponent };